<template>
	<div class="nat-instance-list init">
		<div class="cps-page-top">
			<div class="jc-page-header">
				<el-page-header :title="$t('nat.text.nat')" />
				<div class="jc-box-action">
					<a v-bind:href="Config.NAT_HELP_URL" target="_blank">
						{{ $t('nat.text.helpDoc') }}
					</a>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container-table">
					<div class="jc-container-table-actionBar flex-display">
						<el-form class="jc-table-actionBar-item" :inline="true">
							<el-form-item>
								<el-button icon="jc-icon-refresh-line" class="jc-button-icon" @click="iconRefreshList">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-radio-group v-model="region" @change="regionChange">
									<el-radio-button v-for="(area, index) in regions" :key="index" :label="area.region">
										{{ area.regionName }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="jumpToCreate">
									{{ $t('privateNetInstance.create') }}
								</el-button>
							</el-form-item>
						</el-form>
						<el-form class="jc-box-table-search" :inline="true">
							<el-form-item>
								<el-input :placeholder="placeholderMap[searchType]" v-model="inputValue"
									@keyup.enter.native="handleIconClick" :maxlength="64" class="search-input"
									v-entire-placeholder>
									<el-select v-model="searchType" @change="changeSearch" slot="prepend"
										class="my-select-select">
										<el-option v-for="(search, index) in searchSelect" :key="index"
											:label="search.searchLabel" :value="search.searchValue">
										</el-option>
									</el-select>
									<el-button slot="append" icon="jc-icon-search" class="search-icon"
										@click="handleIconClick">
									</el-button>
								</el-input>
							</el-form-item>
							<!--自定义设置-->
							<el-form-item>
								<el-button class="jc-button-icon operate-icon" icon="el-icon-setting"
									@click="customVisible = true" :title="$t('listPage.text.customList')">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-button class="jc-button-icon operate-icon" icon="jc-icon-download" @click="downloadList"
									:title="$t('listPage.text.exportList')">
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<el-table :data="realTableData" style="width: 100%" @filter-change="filterChange"
						class="jc-table-header-cell jc-list-table" :empty-text="$t('speechCraft.listEmptyText')"
						v-loading="loading">
						<!--ID/名称-->
						<el-table-column :label="$t('privateNetInstance.listTitle.name')" key="id"
							v-if="customInfo !== null && customInfo['id'].selected" min-width="170">
							<template slot-scope="scope">
								<el-tooltip placement="top" :content="scope.row.natGatewayId">
									<p class="instance-id">{{ scope.row.natGatewayId }}</p>
								</el-tooltip>
								<el-tooltip placement="top" :content="scope.row.name">
									<a href="javascript:void(0)"
										@click="jumpToNatDetail(scope.row.natGatewayId, scope.row.region)"
										class="instance-id">
										{{ scope.row.name }}
									</a>
								</el-tooltip>
							</template>
						</el-table-column>
						<!--可用区-->
						<el-table-column :filter-multiple="false" column-key="az" prop="az" min-width="95"
							:filters="filters.azs" :filter-method="filterAz"
							:label="$t('privateNetInstance.listTitle.region')" key="az"
							v-if="customInfo !== null && customInfo['az'].selected">
							<template slot-scope="scope">
								{{ transformAz(scope.row.az) }}
							</template>
						</el-table-column>
						<!--私有网络-->
						<el-table-column :label="$t('subnet.text.privateNetwork')" key="ratio" min-width="110"
							v-if="customInfo !== null && customInfo['ratio'].selected">
							<template slot-scope="scope">
								<el-tooltip :content="scope.row.vpcName" placement="top">
									<p class="instance-id">
										<a href="javascript:void(0)"
											@click="jumpToVpcDetail(scope.row.vpcId, scope.row.region)">
											{{ scope.row.vpcName }}
										</a>
									</p>
								</el-tooltip>
							</template>
						</el-table-column>
						<!--规格类型-->
						<el-table-column :label="$t('nat.text.specificationType')" key="specificationType" min-width="80"
							v-if="customInfo !== null && customInfo['specifications'].selected">
							<template slot-scope="scope">
								<span>
									{{ transformType(scope.row.natGatewayType) }}
								</span>
							</template>
						</el-table-column>
						<!--已绑定EIP -->
						<el-table-column :label="$t('nat.text.bondedEip')" min-width="80"
							v-if="customInfo !== null && customInfo['status'].selected">
							<template slot-scope="scope">
								<a href="javascript:void(0)"
									@click="jumpToNatEipDetail(scope.row.natGatewayId, scope.row.region)">
									{{ scope.row.eipNum }}
								</a>
							</template>
						</el-table-column>
						<!--最大带宽-->
						<el-table-column :label="$t('nat.text.maxBandwidth')" key="config" min-width="80"
							v-if="customInfo !== null && customInfo['config'].selected">
							<template slot-scope="scope">
								<span>
									{{ scope.row.maxBw }}
								</span>
							</template>
						</el-table-column>
						<!--计费信息-->
						<el-table-column :label="$t('privateNetInstance.listTitle.charge')" key="chargeInfo" min-width="200"
							v-if="customInfo !== null && customInfo['chargeInfo'].selected">
							<template slot-scope="scope">
								<div v-if="scope.row.charge.chargeExpiredTime !== undefined">
									<p>
										{{ transformCharge(scope.row.charge.chargeMode) }}
										<span v-if="getCheckExpireInfo(scope.row) === 'will-retire'" class="expire-warning">
											{{ '(' + $t('listPage.text.hasExpired') + ')' }}
										</span>
									</p>
                                    <p class="list-expire-p">
                                        {{ scope.row.charge.chargeStartTime + ' ' + $t('listPage.text.created') }}
                                    </p>
									<p class="expire-warning list-expire-p bill-info-tip"
										v-if="getCheckExpireInfo(scope.row) === 'will-retire' && scope.row.charge.chargeRetireTime">
										{{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
									</p>
									<p class="expire-warning list-expire-p bill-info-tip"
										v-if="getCheckExpireInfo(scope.row) === 'will-expire'">
										{{ scope.row.charge.chargeExpiredTime + ' ' + $t('listPage.text.expired') }}
									</p>
									<p v-if="getCheckExpireInfo(scope.row) === 'available'"
										class="list-expire-p bill-info-tip">
										{{ scope.row.charge.chargeExpiredTime + ' ' + $t('listPage.text.expired') }}
									</p>
								</div>
								<div v-else-if="scope.row.charge.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
									<p>
										{{ transformCharge(scope.row.charge.chargeMode) }}
										<span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
											class="expire-warning expire-warning">
											{{ '(' + $t('privateNetInstance.arrear') + ')' }}
										</span>
									</p>
									<p class="list-expire-p bill-info-tip"
										v-if="scope.row.charge.chargeStatus === 'normal'">
										{{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create') }}
									</p>
									<p class="list-expire-p expire-warning"
										v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.charge.chargeRetireTime">
										{{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
									</p>
								</div>
								<div v-else>
									<span>--</span>
								</div>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column :label="$t('privateNetInstance.listTitle.operate')" key="operation" min-width="110"
							v-if="customInfo !== null && customInfo['operation'].selected">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="openModifySpecificationDialog(scope.row)"
									class="cps-select-form-item"
									:class="{ 'cps-dropdown-disabled': !scope.row.charge.chargeStatus || disableByChargeStatus(scope.row) }">
									{{ $t('nat.text.adjustSpecification') }}
									<!--无计费信息不支持添加操作-->
									<div class="cps-form-tip" v-if="!scope.row.charge.chargeStatus">
										{{ $t('eip.help.noChargeInfo') }}
									</div>
									<!-- 实例已过期/欠费不支持操作 -->
									<div class="cps-form-tip" v-else-if="disableByChargeStatus(scope.row)">
										{{ $t('privateNetInstance.operations.overdueTip') }}
									</div>
								</a>
								<drop-down-operation :showType="'span'" :buttonTitle="$t('privateNetInstance.more')"
									:operations="scope.row.operations" :rowInfo="scope.row" @clickSelectItem="clickOperate">
								</drop-down-operation>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<modify-specification :dialog-visible="modifyDialogVisible" @ifDialogVisible="syncModifyDialog"
					:detailData="rowInfo">
				</modify-specification>
				<bind-eip v-if="bindShow" :visible.sync="bindShow" :region="rowInfo.region"
					:instanceId="rowInfo.natGatewayId" :instanceName="rowInfo.name" :rowInfo="rowInfo"
					@refresh="afterOperateBind">
				</bind-eip>
				<custom v-if="customVisible" :visible.sync="customVisible" :optionArr="optionArr" :type="type">
				</custom>
			</div>
		</div>
		<div v-if="listTotal > 0" class="cps-page-footer block jc-container-table-actionBar">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				:page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="listTotal">
			</el-pagination>
		</div>
		<!--操作保护-->
		<jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="actionType" @success="onSuccess"
			@error="onError">
		</jcb-opt-protect>
		<!--删除-->
		<delete-nat :visible.sync="deleteVisible" @refresh="operateRefresh" :rowInfo="rowInfo" :pageSource="'list'">
		</delete-nat>
	</div>
</template>

<script>

import BindEip from '@/components/nat/BindEip';
import ModifySpecification from '@/components/nat/ModifySpecification';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import custom from '@/components/common/custom/Custom';
import DeleteNat from '@/components/nat/DeleteNat';
import operationProtect from '@/mixins/operationProject';
import {
	ServiceCodeConstant,
	OverdueConstantArray,
	ArrearConstantArray,
	ChargeModeConstant,
	SpecificationTypeParams,
	azName,
} from '@/common/Constants';
import isDestroyingMixins from '@/mixins/isDestroying';

export default {
	name: 'NatList',
	mixins: [operationProtect, isDestroyingMixins],
	components: {
		BindEip,
		dropDownOperation,
		ModifySpecification,
		custom,
		DeleteNat,
	},
	data() {
		return {
			totalCount: 0, // 列表总数
			loading: false,
			azs: [],
			interStatus: ['creating', 'starting', 'stopping', 'restarting', 'upgrading',
				'reinstalling', 'destroying', 'resetting_password'],
			instanceInfo: {},
			rowInfo: {
				charge: {}
			},
			quota: 0,
			natIds: [],
			operationsRenew: false,
			// 自定义列表弹框显示
			customVisible: false,
			// 修改调整规格是否可见
			modifyDialogVisible: false,
			type: 'vpcInstanceList',
			placeholderMap: {
				natGatewayId: this.$t('privateNetInstance.placeholderId'),
				name: this.$t('privateNetInstance.placeholderName'),
			},
			bindShow: false,
			region: '',
			regions: [],
			inputValue: '',
			searchType: 'name',
			tableData: [],
			specificationTypeName: '',
			searchSelect: [
				{
					searchValue: 'natGatewayId',
					searchLabel: this.$t('nat.text.natId')
				},
				{
					searchValue: 'name',
					searchLabel: this.$t('nat.text.natName')
				},
			],
			filters: {
				azs: [],
			},
			filterParams: {
				az: '',
			},
			currentPage: 1,
			pageSizes: [20, 50, 100],
			pageSize: 20,
			optionArr: [
				{
					// ID/名称
					label: this.$t('nat.text.name'),
					value: 'id'
				},
				{
					// 可用区
					label: this.$t('privateNetInstance.listTitle.region'),
					value: 'az'
				},
				{
					// 私有网络/子网
					label: this.$t('privateNetInstance.listTitle.privateAndSub'),
					value: 'ratio'
				},
				{
					// 已绑定eip
					label: this.$t('nat.text.bondedEip'),
					value: 'status'
				},
				{
					// 规格类型
					label: this.$t('privateNetInstance.listTitle.spc'),
					value: 'specifications'
				},
				{
					// 最大带宽
					label: this.$t('nat.text.maxBandwidth'),
					value: 'config'
				},
				{
					// 计费信息
					label: this.$t('privateNetInstance.listTitle.charge'),
					value: 'chargeInfo'
				},
				{
					// 操作
					label: this.$t('privateNetInstance.listTitle.operate'),
					value: 'operation'
				}
			],
			statusTimeOut: null,
			// 标签过滤后的资源ID
			filteredResourceIds: [],
			// 删除实例弹框
			deleteVisible: false,
		};
	},
	computed: {
		ServiceCodeConstant: () => ServiceCodeConstant,
		customInfo() {
			return this.$store.state.customInfo[this.type];
		},
		realTableData() {
			if (typeof this.tableData === 'undefined') {
				return [];
			}
			if (this.tableData.length === 0) {
				return [];
			}
			return this.tableData.map((item) => {
				const operations = [
					// 绑定eip
					{
						operateName: this.$t('privateNetInstance.operations.bind'),
						disabled: !item.charge.chargeStatus || this.disableByChargeStatus(item),
						tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.disableByChargeStatus(item) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyNotError'),
						value: 'bind'
					},
				];
				// 续费
				operations.splice(2, 0, {
					operateName: this.$t('privateNetInstance.operations.repay'),
					disabled: !item.charge.chargeStatus,
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : '',
					value: 'repay'
				});
				// 删除实例特殊处理
				const deleteOperate = {
					operateName: this.$t('operations.delete.name'),
					disabled: item.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
						|| !item.charge.chargeStatus,
					value: 'delete',
					tip: ''
				};
				if (item.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
					deleteOperate.tip = this.$t('operations.delete.tip');
				}
				if (!item.charge.chargeStatus) {
					deleteOperate.tip = this.$t('eip.help.noChargeInfo');
				}
				operations.push(deleteOperate);
				item.operations = operations;
				return item;
			});
		},
		/**
		 * 返回查询到的列表总数
		 * @return {number}
		*/
		listTotal() {
			return this.totalCount;
		},
		OverdueConstantArray: () => OverdueConstantArray,
		ArrearConstantArray: () => ArrearConstantArray,
		ChargeModeConstant: () => ChargeModeConstant,
		SpecificationTypeParams: () => SpecificationTypeParams,
		azName: () => azName,
	},
	created() {
		if (this.$store.state.customInfo[this.type] === null) {
			this.getCustomInfo();
		}
		this.getRegions();
	},
	watch: {
		region(newValue) {
			if (newValue) {
				this.regionChange()
			}
		},
	},
	destroyed() {
		clearTimeout(this.statusTimeOut);
	},
	methods: {
		/**
		 * 判断当前时间与到期、释放时间关系
		 * @param row
		 * @return {string}
		*/
		getCheckExpireInfo(row) {
			if (row.charge.chargeExpiredTime !== undefined) {
				const now = Date.now();
				const expire = (new Date(row.charge.chargeExpiredTime)).getTime();
				const DAYS = 1000 * 60 * 60 * 24;
				if (now > expire && row.charge.chargeRetireTime) {
					return 'will-retire';
				}
				if (expire - now > 7 * DAYS) {
					return 'available';
				}
				return 'will-expire';
			}
		},
		// 判断操作是否应该因不正确的计费状态而被禁用
		disableByChargeStatus(row) {
			if (OverdueConstantArray.includes(row.charge.chargeStatus)) {
				return true;
			}
			return false;
		},
		// 切换可用区
		regionChange() {
			// TODO remember to clear search
			this.inputValue = '';
			this.pageSize = 20;
			this.currentPage = 1;
			this.searchType = 'name';
			const params = {
				region: this.region,
			};
			Object.keys(this.filterParams).forEach((filter) => {
				this.filterParams[filter] = '';
			});
			this.refreshList(params);
			this.getFilterLists();
		},
		// 获得可用区
		getRegions() {
			const params = {

			};
			Ajax.get('api/cps/getRegions', params).then((res) => {
				const target = this;
				if (res.data) {
					res.data.regions.forEach((region, index) => {
						if (index === 0) {
							if (target.$route.query && target.$route.query.region) {
								target.region = target.$route.query.region;
							} else {
								target.region = region.region;
							}
						}
						const tempFormat = {};
						tempFormat.region = region.region;
						tempFormat.regionName = region.regionName;
						target.regions.push(tempFormat);
					});
				}
			});
		},
		// 查询nat网关列表
		getNatList(params) {
			return Ajax.get('/api/cps/nat/queryNatGatewayPage', params).then((res) => {
				if (res.data) {
					// 格式化返回的标签键值对
					this.tableData = res.data.natGateways;
					this.totalCount = res.data.totalCount;
				}
			}).catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					//this.$message.error(json.errmsg);
					this.tableData = [];
					this.totalCount = 0;
				} catch (e) {
					console.log(e);
				}
			})
				.finally(() => {
					this.loading = false;
				});
		},
		getFilterLists() {
			const params = {
				region: this.region,
				networkType: 'vpc'
			};
			Ajax.get('/api/filter/listInstances', params).then((res) => {
				if (res.errno === 10000 && res.data) {
					Object.keys(res.data).forEach((key) => {
						const filtersArray = [];
						const filtersObj = res.data[key];
						Object.keys(filtersObj).forEach((item) => {
							const temp = {};
							temp.value = item;
							temp.text = filtersObj[item];
							filtersArray.push(temp);
						});
						this.filters[key] = filtersArray;
					});
				}
			}).finally(() => {
				this.azs = this.filters.azs;
				this.loading = false;
			});
		},
		handleIconClick() {
			this.currentPage = 1;
			const params = {};
			if (this.inputValue !== '') {
				if (this.searchType === 'name') {
					params.name = this.inputValue.replace(/ /g, '');
				} else if (this.searchType === 'natGatewayId') {
					params.natGatewayId = this.inputValue.replace(/ /g, '');
				}
			}
			this.refreshWithLoading(params);
		},
		filterAz(value, row) {
			return row.az === value;
		},
		// 续费
		renew(id) {
			const params = {
				resourceId: id,
				region: this.region,
				serviceCode: ServiceCodeConstant.CPSNAT,
			};
			Ajax.get('/api/order/submitRenew', params).then((res) => {
				const tempOrderId = res.data.tmpOrderId;
				window.location.href = `${this.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${tempOrderId}&resourceType=cpsnat`;
			});
		},
		openModifySpecificationDialog(row) {
			this.rowInfo = row;
			if (!row.charge.chargeStatus || this.disableByChargeStatus(row)) {
				return false;
			}
			this.modifyDialogVisible = true;
		},
		// 同步调整规格子组件传出来的dialog是否显示
		syncModifyDialog(data) {
			this.modifyDialogVisible = data;
		},
		clickOperate(value, rowInfo) {
			this.rowInfo = rowInfo;
			switch (value) {
				case 'bind':
					this.bindShow = true;
					break;
				case 'repay':
					this.renew(rowInfo.natGatewayId);
					break;
				case 'delete':
					this.deleteVisible = true;
					break;
				default:
					break;
			}
		},
		/**
		 * @param size
		 * 改变当前每页条数时触发
		*/
		handleSizeChange(size) {
			this.pageSize = size;
			this.currentPage = 1; // 切换每页条数时自动返回第一页
			const params = {
				pageSize: size,
			};
			this.refreshWithLoading(params);
		},
		handleCurrentChange(page) {
			this.currentPage = page;
			const params = {
				pageNumber: page
			};
			this.refreshWithLoading(params);
		},
		//查询nat配额
		getNatQuota() {
			const params = {
				region: this.region,
			};
			Ajax.get('/api/cps/nat/natQuota', params)
				.then((res) => {
					this.quota = res.data.availableQuota;
				});
		},
		// 刷新列表
		refreshList(params) {
      if (this.isDestroying) {
          return
      }
			const defaultParams = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
			if (this.inputValue !== '') {
				if (this.searchType === 'name') {
					defaultParams.name = this.inputValue.replace(/ /g, '');
				} else if (this.searchType === 'natGatewayId') {
					defaultParams.natGatewayId = this.inputValue.replace(/ /g, '');
				}
			}
			Object.keys(this.filterParams).forEach((key) => {
				if (this.filterParams[key] !== '') {
					defaultParams[key] = this.filterParams[key];
				}
			});
			const realParams = Object.assign({}, defaultParams, params);
			this.getNatList(realParams).then(() => {
				const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
				if (refreshTag) {
					this.statusTimeOut = setTimeout(() => {
						this.refreshList(realParams);
					}, 5000);
				}
			});

		},
		// 临时增加遮罩层
		refreshWithLoading(params, ifFilter = false) {
      if (this.isDestroying) {
          return
      }
			this.loading = true;
			const defaultParams = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
			if (this.inputValue !== '') {
				if (this.searchType === 'name') {
					defaultParams.name = this.inputValue.replace(/ /g, '');
				} else if (this.searchType === 'natGatewayId') {
					params.natGatewayId = this.inputValue.replace(/ /g, '');
				}
			}
			if (ifFilter) {
				defaultParams.natGatewayId = this.filteredResourceIds.join(',');
			}
			Object.keys(this.filterParams).forEach((key) => {
				if (this.filterParams[key] !== '') {
					defaultParams[key] = this.filterParams[key];
				}
			});
			const realParams = Object.assign({}, defaultParams, params);
			this.getNatList(realParams).then(() => {
				this.loading = false;
				const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
				if (refreshTag) {
					this.statusTimeOut = setTimeout(() => {
						this.refreshList(defaultParams);
					}, 5000);
				}
			}).finally(() => {
				this.loading = false;
			});
		},
		// 下载列表
		downloadList() {
			const params = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
			Object.keys(this.filterParams).forEach((param) => {
				if (this.filterParams[param] !== '') {
					params[param] = this.filterParams[param];
				}
			});
			if (this.inputValue !== '') {
				if (this.searchType === 'name') {
					params.name = this.inputValue.replace(/ /g, '');
				} else if (this.searchType === 'natGatewayId') {
					params.natGatewayId = this.inputValue.replace(/ /g, '');
				}
			}
			Ajax.download('GET', '/api/export/exporNatGateways', params);
		},
		iconRefreshList() {
			const params = {};
			this.refreshWithLoading(params);
		},
		filterChange(filter) {
			this.currentPage = 1;
			const params = {};
			Object.keys(filter).forEach((key) => {
				if (key === 'az') {
					this.filterParams.az = filter[key][0];
				}
				params[key] = filter[key][0];
			});
			clearTimeout(this.statusTimeOut);
			this.refreshList(params);
		},
		// 自定义列
		getCustomInfo() {
			const params = {
				pageKey: this.type
			};
			Ajax.get('/api/usercenter/getCustomInfo', params).then((res) => {
				if (res.data.customInfo) {
					this.$store.commit(
						'GET_CUSTOMINFO',
						{ value: res.data.customInfo, type: this.type }
					)
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		afterOperateBind() {
			this.refreshWithLoading({});
		},
		operateRefresh() {
			this.refreshWithLoading({});
		},
		checkExpire(row) {
			if (row.charge.chargeExpiredTime !== undefined) {
				const nowDate = new Date();
				const expireDate = new Date(row.charge.chargeExpiredTime);
				const retireDate = new Date(row.charge.chargeRetireTime);
				const nowTime = nowDate.getTime();
				const expireTime = expireDate.getTime();
				const retireTime = retireDate.getTime();
				if (retireTime - nowTime < 7 * 24 * 3600 * 1000) {
					return 'will-retire';
				}
				if (expireTime - nowTime < 7 * 24 * 3600 * 1000) {
					return 'will-expire';
				}
				return 'available';
			}
		},
		transformType(type) {
			switch (type) {
				case 'small':
					return this.$t('nat.text.small');
				case 'medium':
					return this.$t('nat.text.middle');
				case 'large':
					return this.$t('nat.text.large');
				case 'xlarge':
					return this.$t('nat.text.xlarge');
				default:
					return '';
			}
		},
		transformCharge(payMethod) {
			switch (payMethod) {
				case 'prepaid_by_duration':
					return this.$t('privateNetInstance.monthAndYear');
				case 'postpaid_by_duration':
					return this.$t('create.text.byConfigurations');
				default:
					return '';
			}
		},
		jumpToCreate() {
			this.$router.push({
				path: '/nat/create',
				query: { region: this.region }
			});
		},
		jumpToSubnet(id, region) {
			this.$router.push({
				path: '/subnet/detail',
				query: {
					id,
					region
				}
			});
		},
		jumpToVpcDetail(id, region) {
			this.$router.push({
				path: '/vpc/detail',
				query: {
					id,
					region,
					tabName: 'source'
				}
			});
		},
		jumpToNatDetail(id, region) {
			this.$router.push({
				path: '/nat/detail',
				query: {
					id,
					region,
					tabName: 'sourceInfo'
				}
			});
		},
		jumpToNatEipDetail(id, region) {
			this.$router.push({
				path: '/nat/detail',
				query: {
					id,
					region,
					tabName: 'eip'
				}
			});
		},
		transformAz(vaule) {
			let realAz;
			this.azs.forEach((az) => {
				if (az.value === vaule) {
					realAz = az.text;
				}
			});
			return realAz;
		},
		changeSearch() {
			this.inputValue = '';
		},
		getRegionName(region) {
			let regionName = '';
			this.regions.forEach((item) => {
				if (region === item.region) {
					regionName = item.regionName;
				}
			});
			return regionName;
		},
	},

};
</script>

<style lang="scss">
@import '../../../assets/scss/listComon';
@import '../../../assets/scss/paginationCommon';
@import '../../../assets/scss/sliderCommon';
@import '../../../assets/scss/statusCommon';
</style>



// WEBPACK FOOTER //
// src/views/nat/list/List.vue